import { navigationGroups } from '../constant';

// The most specific path wins, so /workflows/themes marks Themes and not Workflows.
export function getActiveItemId(pathname) {
    const matches = navigationGroups
        .flatMap((group) => group.items)
        .filter((item) => pathname === item.path || pathname.startsWith(`${item.path}/`))
        .sort((a, b) => b.path.length - a.path.length);

    return matches[0]?.id;
}

// The default item comes first, the rest A to Z.
export function sortDefaultFirst(items, defaultKey) {
    const defaults = items.filter((item) => item[defaultKey]);
    const others = items
        .filter((item) => !item[defaultKey])
        .sort((a, b) => a.name.localeCompare(b.name));

    return [...defaults, ...others];
}

// Perceived brightness of a hex colour, used to spot logos made for dark headers.
export function isDarkColor(hex) {
    const value = /^#?([0-9a-f]{6})$/i.exec(hex)?.[1];
    if (!value) {
        return false;
    }
    const red = parseInt(value.slice(0, 2), 16);
    const green = parseInt(value.slice(2, 4), 16);
    const blue = parseInt(value.slice(4, 6), 16);

    return (red * 299 + green * 587 + blue * 114) / 1000 < 128;
}
